// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2Oil8","footer":"ModalInfo_footer__3BGCf"};